module.exports = __webpack_public_path__ + "513eba1f6966a999f364baeb5ca08c5d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/spotin_portal.png
// module id = 214
// module chunks = 0